<template>
  <div class="main">
    <div class="chart-wrapper">
      <div class="dashboard-kpi p-2">
        <div class="text-bold text-center">Supplier Satisfaction Index</div>
        <div class="content-wrapper">

          <p class="">Mohon untuk konfirmasi penilaian tingkat kepuasan pengadaan dibawah ini, apabila tidak sesuai,
            mohon
            untuk disesuaikan menjadi data valid : </p>
          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Tanggal PO</th>
                  <th>Nomor PO</th>
                  <th>Nama Vendor</th>
                  <th>Nilai</th>
                  <th>Tingkat Kepuasan</th>
                  <th>Nilai PO</th>
                  <th>Dokumen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <td>{{ formatDate(item.PO_DATE) }}</td>
                  <td>{{ item.PO_NUMBER }}</td>
                  <td>{{ item.VENDOR_NAME }}</td>
                  <td>
                    <select name="nilai" id="" v-model="item.CSI_SCORE">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </td>
                  <td>{{ satisfies(item.CSI_SCORE) }}</td>
                  <td>{{ curencyDelimiter(item.TOTAL_VALUE_IDR) }}</td>
                  <td v-if="item.CSI_SCORE < 3 && item.CSI_SCORE != 0" class="col-elipsis"
                    style="width: auto; max-width:30px;">
                    <div class="btn btn-default btn-file column100"
                      style="justify-content: center;align-items: center;">
                      <i class="fas fa-download mr-2" @click="downloadDoc(item.DOKUMENT)"
                        v-if="!item.document && item.DOKUMENT != '' && item.DOKUMENT != null"></i>
                      <label>
                        <i class="fas fa-upload"></i>
                        <span class="all-column">
                          {{
                            item.document && Array.isArray(item.document)
                              ? item.document[0].name
                              : item.DOKUMENT
                          }}
                        </span>
                        <input type="file" style="display: none;" @change="(e) => fileChangeHandler(e, index)" />
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="foot-note">
            <p>*Apabila nilai tingkat kepuasan dibawah 3, wajib untuk melampirkan dokumen SP</p>
            <button @click="confirmData">Simpan</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueJwtDecode from 'vue-jwt-decode'
import axios from 'axios'
import { api } from '@/services/config'

export default {
  components: {
  },
  data() {
    return {
      data: [
        {
          tanggalPO: '2023-07-03',
          nomorPO: 'PO003',
          namaVendor: 'Vendor 3',
          nilai: 3,
          kepuasan: 'Rendah',
          nilaiPO: 2700,
          dokumen: 'Dokumen SP',
        },
        {
          tanggalPO: '2023-07-04',
          nomorPO: 'PO004',
          namaVendor: 'Vendor 4',
          nilai: 4,
          kepuasan: 'Sangat Buruk',
          nilaiPO: 3600,
          dokumen: 'Dokumen SP',
        },
      ],
      list: []
    }
  },
  created() {
    const { token, pic_number } = this.$route.query
    let decoded = VueJwtDecode.decode(token)
    let { data } = decoded
    let newData = []

    for (let i in data) {
      newData.push({
        ...data[i],
        pic_number,
        document: null
      })
    }

    this.list = newData

  },
  methods: {

    fileChangeHandler(e, index) {
      let files = Array.from(e.target.files)

      this.list[index].document = files
    },

    satisfies(val) {
      if (val == 0) {
        return 'Belum Di Nilai'
      } else if (val == 1) {
        return 'Sangat Buruk'
      } else if (val == 2) {
        return 'Tidak Puas'
      } else if (val == 3) {
        return 'Cukup Puas'
      } else if (val == 4) {
        return 'Puas'
      } else if (val == 5) {
        return 'Sangat Puas'
      }

    },

    checkScore() {
      let score = 0
      for (let item of this.list) {
        if (item.CSI_SCORE == 0) {
          score += 1
        }
      }

      if (score > 0) {
        return true
      } else {
        return false
      }
    },

    checkDocumentUpload() {
      let document = 0
      for (let item of this.list) {
        if (item.CSI_SCORE < 3 && item.CSI_SCORE != 0) {
          if ((item.document && item.document.length > 0 && Array.isArray(item.document) && 'name' in item.document[0]) ||
            (item.DOKUMENT && item.DOKUMENT != '' && item.DOKUMENT != null)
          ) {
            document += 0
          } else {
            document += 1
          }
        }
      }

      if (document > 0) {
        return true
      } else {
        return false
      }
    },

    async confirmData() {

      if (this.checkScore()) {
        alert('Mohon untuk mengisi nilai penilaian, nilai tidak boleh 0')
        return false
      }

      if (this.checkDocumentUpload()) {
        alert('Mohon untuk mengupload dokumen SP')
        return false
      }

      try {
        this.$store.commit('level1/SET_LOADING', true)
        let formData = new FormData()
        for (let i in this.list) {
          formData.append('CSI_SCORE[]', this.list[i].CSI_SCORE)
          formData.append('PO_NUMBER[]', this.list[i].PO_NUMBER)
          formData.append('GR_ID[]', this.list[i].GR_ID)
          formData.append('PO_DATE[]', this.list[i].PO_DATE)
          formData.append('VENDOR_NAME[]', this.list[i].VENDOR_NAME)
          formData.append('TOTAL_VALUE_IDR[]', this.list[i].TOTAL_VALUE_IDR)
          formData.append('CSI_DESCRIPTION[]', this.satisfies(this.list[i].CSI_SCORE))
          formData.append('pic_number[]', this.list[i].pic_number)
          if (this.list[i].document && this.list[i].document.length > 0 && Array.isArray(this.list[i].document) && 'name' in this.list[i].document[0]) {
            formData.append('document[]', this.list[i].document[0])
            formData.append('indexFile[]', i)
          } else {
            formData.append('indexFile[]', this.list[i].DOKUMENT)
          }
        }

        const { data } = await axios({
          url: `${api}/api/v1/dashboard-kpi/confirm`,
          method: 'POST',
          data: formData
        })

        if (data && data.status == 'success') {
          this.$store.commit('level1/SET_LOADING', false)
          this.$router.push('/')
        } else {
          alert('Server Error')
        }
      } catch (error) {
        this.$store.commit('level1/SET_LOADING', false)
      }
    },

    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
  }
}
</script>

<style scoped>
.table-wrapper {
  margin-top: 2rem;
  margin-left: auto;
  margin-right: auto;
  max-height: 300px;
  overflow-y: scroll;
  width: 100%;
}

table {
  /* margin: 2rem auto 0 auto; */
  margin: 0 auto;
  width: 100%;
  color: var(--gray-900, #101828);
  /* text-align: center; */
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

table,
tr,
td {
  border: none;
}

.main {
  /* width: 85vw; */
  width: 100%;
  height: 78vh;
  background-color: pink;
  overflow: auto;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
}

.chart-wrapper {
  width: 100%;
  max-width: 73%;
  box-shadow: -6px 5px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}

.foot-note {
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.foot-note button {
  width: 89px;
  /* align-self: stretch; */
  border-radius: 8px;
  border: 1px solid var(--gray-300, #D0D5DD);
  background: var(--base-white, #FFF);

  /* Shadow/xs */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  color: var(--gray-700, #344054);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
}
</style>